'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _buttons = require('@sitebase/ui-kit/es/buttons');

var _currencySignFormatter = require('../../utils/currencySignFormatter');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AmountButton = function AmountButton(_ref) {
  var key = _ref.key,
      amountValue = _ref.amountValue,
      currencyCode = _ref.currencyCode,
      onClick = _ref.onClick,
      tabIndex = _ref.tabIndex;
  return _react2.default.createElement(
    _buttons.Button,
    { type: 'button', onClick: onClick, tabIndex: tabIndex, key: key, outfit: 'large' },
    '+ ',
    (0, _currencySignFormatter.currencySignFormatter)(amountValue, currencyCode)
  );
};

exports.default = AmountButton;